<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/h8flH4/tc-custom/9780830863907.jpg?1696024485676" alt="This image is the cover for the book Life's Big Questions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Life's Big Questions
      </h1>
      <p class="bookDescription body article font2">
        <p>How can the sixty-six books of the Bible have a single message for us today? What unites the vastly different accounts of God's work in the world? How do the various genres of the Bible work together? Vaughan Roberts believes that the Bible tells a single story for all time. He draws out the Bible's message of Jesus Christ and God's redemption through him in six big questions:</p>  Who rules the world? What does it mean to be human? How should we view money? Is a perfect relationship possible? How does the Holy Spirit work in the world and in our lives? What is God's plan for the world?  <p>This companion volume to Roberts's previous book, <em>God's Big Picture</em>, will not only help you answer these questions, but also give you tools to transform your own Bible study in light of the whole story of God.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vaughan Roberts
      </h2>
      
      <p class="authorDescription body article"><p>Vaughan Roberts is rector of St. Ebbe's Church in Oxford, England, and author of <em>God's Big Picture</em> and <em>Life's Big Questions.</em> He is also a popular speaker at Spring Harvest and a founding member of "9:38" which encourages people to consider full-time gospel ministry.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?448d698e